import * as React from "react";
const SvgHidePasswordIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} stroke="#A1ACC3" viewBox="0 0 16 16" {...props}><path d="M4.313 8.924a20 20 0 0 0-2.883 3.181s4.611 6.64 10.283 6.64c.72 0 1.43-.1 2.121-.3M9.598 5.76c.685-.2 1.4-.3 2.115-.3 5.672 0 10.289 6.645 10.289 6.645a19.8 19.8 0 0 1-2.883 3.176" style={{
    fill: "none",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }} transform="scale(.66667)" /><path d="M11.818 7.986A4.13 4.13 0 0 1 14.62 9.2 4.1 4.1 0 0 1 15.832 12M7.594 12.205a4.18 4.18 0 0 0 1.213 2.807 4.16 4.16 0 0 0 2.8 1.213M3.908 4.3l15.61 15.61" style={{
    fill: "none",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }} transform="scale(.66667)" /></svg>;
export { SvgHidePasswordIcon as ReactComponent };